import { render, staticRenderFns } from "./popupContainer.vue?vue&type=template&id=34084aff&scoped=true&"
import script from "./popupContainer.vue?vue&type=script&lang=ts&"
export * from "./popupContainer.vue?vue&type=script&lang=ts&"
import style0 from "./popupContainer.vue?vue&type=style&index=0&id=34084aff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34084aff",
  null
  
)

export default component.exports